import { Path, Segment } from "paper/dist/paper-core";

export default class Nose extends Path {
  constructor() {
    super({
      segments: [
        new Segment({
          point: [50 - 3, 46],
          handleOut: [2, 1],
        }),
        new Segment({
          point: [50 + 3, 46],
          handleIn: [-2, 1],
        }),
      ],
      strokeColor: "#2d415e",
      strokeWidth: 1,
    });
  }
}
